// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header .am-search-input{\n    flex: initial;\n}", "",{"version":3,"sources":["webpack://./app/components/Mobile/searchHeaders/searchHeaders.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB","sourcesContent":[".header .am-search-input{\n    flex: initial;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
